export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: '人气榜、评分榜和必看榜有什么区别？',
    answer:
      '人气榜根据读者实时追更热度动态排序，反映当下最热门的作品；评分榜由资深读者与编辑共同评定，是口碑与质量的双重保证；必看榜则更偏入门推荐，适合刚接触韩漫的读者快速建立审美。三张榜单互补，可按你的需求选择。',
  },
  {
    question: '榜单多久更新一次？',
    answer:
      '人气榜会依据读者追更与互动热度实时更新，评分榜与必看榜则由编辑周期性复核调整。你可以在每个榜单页看到当前排序，按热度与评分快速锁定值得追的韩国漫画。',
  },
  {
    question: '在哪里可以阅读这些韩国漫画？',
    answer:
      '本榜单作为韩漫选漫参考，会标注作品的类型、作者、评分与连载状态。具体的阅读需要在拥有正版版权的漫画平台进行，我们建议优先支持正版，维护创作者生态。',
  },
  {
    question: '评分高就一定适合我吗？',
    answer:
      '不一定。高分代表作品整体质量与口碑出色，但每个人的喜好不同。建议先通过分类、标签和剧情简介筛选，再结合评分决定是否入坑，这样更容易找到真正合你口味的作品。',
  },
  {
    question: '如何快速找到我喜欢的类型？',
    answer:
      '你可以在首页按分类浏览，也可以使用顶部搜索框输入作品名或类型关键词，快速定位到人气榜中对应的作品。榜单页还支持按分类筛选，让选漫更高效。',
  },
  {
    question: '如何提交作品推荐或反馈意见？',
    answer:
      '欢迎通过页面底部的联系邮箱给我们留言，告诉我们你心中的宝藏韩漫或对榜单的建议。我们会定期收集读者反馈，让榜单更贴近大家的真实喜好。',
  },
];